var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-layout',{staticClass:"white"},[_c('v-card',{attrs:{"flat":true}},[_c('v-card-text',{staticClass:"text-xs-center py-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }